var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-12"},[_c('v-img',{staticClass:"my-6",attrs:{"src":require("@/static/svg/three-dots.svg"),"height":"20","contain":""}}),_c('h3',{staticClass:"text-center grey--text",domProps:{"textContent":_vm._s(_vm.message)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }